import isObject from 'lodash/isObject';
import axios from '../../../system/rest/axios';
import RestService from '../../../system/rest/rest.service';
import Config from '../../../system/config';

/**
 * @param {Object} response
 * @throws Error
 */
function parseErrorResponse(response) {
    if (isObject(response) && response.hasOwnProperty('data')) {
        if (isObject(response.data) && response.data.hasOwnProperty('message')) {
            throw new Error(response.data.message);
        }
    }
    throw new Error('Chyba požadavku');
}

/**
 * @param {Object} credentials
 * @return {Promise<any>}
 */
export async function userSignIn(credentials) {
    return axios.post(Config.AUTH_DOMAIN + '/v1/sign/in', credentials)
        .catch(({response}) => parseErrorResponse(response))
}

/**
 * @return {Promise<any>}
 */
export async function userKeepalive() {
    return axios.get(Config.AUTH_DOMAIN + '/v1/keepalive')
        .catch(({response}) => parseErrorResponse(response))
}


/**
 * @return {Promise<any>}
 */
export async function userLogout() {
    return axios.get(Config.AUTH_DOMAIN + '/v1/sign/out')
        .catch(({response}) => parseErrorResponse(response))
}

/**
 * @param {Object} credentials
 * @return {Promise<void>}
 */
export async function userMe() {
    return RestService.get(Config.AUTH_DOMAIN + '/v1/me');
}
